import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import 'react-phone-number-input/style.css';
import API from '../../../utils/API';
import * as modalUtils from '../../../utils/modalUtils';
import useModalInitializationForSites from '../../../hooks/useModalInitializationForSites';
import DropdownGroup from '../../../components/SignagePlus/DropdownGroup';
import { use } from 'react';

const modalId = 'assignSiteModal';

function SignageAssignSiteModal({ setSuccess, loadTable, dataMap, selectedUserIds, setSiteLength }) {
  const [modalError, setModalError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [site, setSite] = useState('');

  const {
    // State
    cms,
    sites,
    selectedSiteIds,
    setSiteIds,
    siteDropdownError,
    setSiteDropdownError,
    // Computed values
    selectedSitesCount,
    selectedSitesText,
    selectedSiteCmsIds,
    // Handlers
    closeModal,
    // Helper functions
    generateSiteComponents
  } = useModalInitializationForSites({
    modalId,
    multiSelect: true,
    siteExtractor: modalUtils.extractArrayBasedSiteInfo
  });

  /**
    * Reset modal
    */
  function resetModal() {
    setSubmitted(false);
    setModalError('');
    setSiteDropdownError('');
  }

  const siteComponents = generateSiteComponents();

  // Reset feature error when modal is shown/hidden
  useEffect(() => {
    const modal = document.getElementById(modalId);

    if (modal) {
      const handleModalShow = () => {
        resetModal();
      };

      const handleModalHidden = () => {
        resetModal();
      };

      modal.addEventListener('show.bs.modal', handleModalShow);
      modal.addEventListener('hidden.bs.modal', handleModalHidden);

      return () => {
        modal.removeEventListener('show.bs.modal', handleModalShow);
        modal.removeEventListener('hidden.bs.modal', handleModalHidden);
      };
    }
  }, []);

  useEffect(() => {
    if (selectedSiteIds.length === 0) {
      setSiteDropdownError(<FormattedMessage id="NO_SITES_SELECTED" />);
    } else {
      setSiteDropdownError('');
    }
    if (siteDropdownError === '') {
      setModalError('');
    }
  }, [selectedSiteIds]);

  useEffect(() => {
    setSiteLength(sites.length);
  }, [sites]);

  /**
   * Add new group to the database
   */
  const handleAssignUsersToSites = async () => {
    try {
      let res = await API.putAssignSitesForSignagePlusUsr(selectedSiteCmsIds[0], selectedSiteIds, selectedUserIds);
      if (res.status === 200) {
        setSuccess(<FormattedMessage id="ASSIGN_SITE_SUCCESS" />);
      }

      if (typeof loadTable === 'function') loadTable(dataMap);
      closeModal(/*modalId*/);
      resetModal();
    } catch (err) {
      setModalError(<FormattedMessage id="ASSIGN_SITE_FAIL" />);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);

    if (selectedSiteIds.length === 0) {
      setSiteDropdownError(<FormattedMessage id="NO_SITES_SELECTED" />);
    }

    if (!siteDropdownError) {
      handleAssignUsersToSites();
    } else {
      setModalError(<FormattedMessage id="SUBMIT_ERROR" />);
    }
  };

  // selectedSitesCount and selectedSitesText are provided by the hook

  return (
    <div className="modal modal-mse fade" id="assignSiteModal" tabIndex="-1" aria-labelledby="assignSiteModal" aria-hidden="true">
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content modal-mes-content' style={{ overflow: 'visible' }}>
          <div className='modal-header modal-mes-header' style={{ backgroundColor: '#347BFA' }}>
            <h5 className="modal-title  modal-mes-title"><FormattedMessage id="ASSIGN_CMS_SITE" defaultMessage="Assign CMS/Site" /></h5>
            <button type="button" id="closeSitesModal" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className='modal-body' style={{ overflow: 'visible' }}>
            <form onSubmit={handleSubmit}>
              <div className='row' >
                <div className='folderNameSection mb-2'>
                  <label htmlFor='folderNameLabel' className='font-weight-600 font-size-14 mb-2'>
                    <FormattedMessage id={'CMS'} />:
                  </label>
                  <input
                    id="CMSNameInput"
                    value={cms}
                    name='CMSName'
                    readOnly
                    className='form-control h-54 bg-baby-blue'
                  />
                </div>
              </div>
              <div className='row mt-3' >
                <div className="mb-3">
                  <label className="font-weight-600 font-size-14 mb-2" htmlFor='btnSiteDrop' ><FormattedMessage id="SELECT_SITE" />:</label>
                  <DropdownGroup
                    options={siteComponents}
                    value={site}
                    onChange={(value) => setSite(value)}
                    text="SELECT_SITE"
                    selectedSitesText={selectedSitesText}
                    selectedSitesCount={selectedSitesCount}
                    className={`form-control h-54 bg-baby-blue ${submitted && (siteDropdownError ? 'is-invalid' : 'is-valid')}`}
                  />
                  {submitted && siteDropdownError && (
                    <div className='d-block invalid-feedback'>
                      {siteDropdownError}
                    </div>
                  )}
                </div>
                {modalError && (
                  <div className='modal-error invalid-feedback d-block fw-bold text-center'>
                    {modalError}
                  </div>
                )}
              </div>
            </form>
          </div>
          <div className='modal-footer modal-mes-footer d-flex align-items-center'>
            <button id="assignSiteBackBtn" className='btn btn-outline-secondary me-3' type="button" data-bs-dismiss="modal"><FormattedMessage id="BACK" /></button>
            <button id="assignSiteSaveBtn" className='btn btn-primary but-darkblue' type="submit" onClick={handleSubmit}><FormattedMessage id="SAVE" /></button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignageAssignSiteModal;
